import React from "react";
import AgentProfile from "../../components/public/userAgentDetails/AgentProfile";
import PopularProperties from "../../components/public/userAgentDetails/PopularProperties";

const AgentDetails = () => {
  return (
    <div className="overflow-hidden">
      <AgentProfile />
      <PopularProperties />
    </div>
  );
};

export default AgentDetails;
